import { CiamProvider } from '@subscriber/ciam';

const AuthenticationProvider = ({ children }) => {
  let brandGroup;
  switch (MH_GROUP) {
    case 'DL':
      brandGroup = 'mhli';
      break;
    case 'LUX':
      brandGroup = 'mh';
      break;
    case 'BE':
    default:
      brandGroup = 'mhbe';
      break;
  }
  return (
    <CiamProvider
      autoAuthentication={['BE', 'DL', 'LUX'].includes(MH_GROUP)}
      brand={MH_BRAND}
      brandGroup={brandGroup}
      clientId={CIAM_CLIENT_ID}
      environment={MH_ENV === 'test2' ? 'test' : MH_ENV}
    >
      {children}
    </CiamProvider>
  );
};

export default AuthenticationProvider;
